/* -------------------------------------------------------------------------- */
/*                        Schema Vehicle Makers                               */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const vehicleMaker = new schema.Entity('vehicleMakers', {}, { idAttribute: 'makerId' });
export const vehicleMakers = new schema.Array(vehicleMaker);
